export const MainBanner = () => {}
